import { getApp } from 'firebase/app'
import { getStorage, ref, uploadBytes } from 'firebase/storage'

import Constants from 'Constants'

const { IMAGE_UPLOADS_PRIVATE_BUCKET_NAME } = Constants

type UploadExceptionMediaFileArgs = {
  businessId: string
  accountId: string
  workOrderId: string
  exceptionId: string
  file: File
}

/** Sanitizes a user filename into a path-safe GCS object segment ('media' fallback). */
export const sanitizeMediaFileName = (fileName: string | null | undefined): string => String(fileName || 'media').replace(/[^\w.-]/g, '_')

/** Unique per upload — concurrent same-named files must not collide onto one object and overwrite each other. */
export const buildUniqueMediaObjectName = (fileName: string | null | undefined): string =>
  `${crypto.randomUUID()}-${sanitizeMediaFileName(fileName)}`

/**
 * Client-direct upload of a WO-exception media file to the private uploads bucket at
 * {businessId}/accounts/{accountId}/work_orders/{workOrderId}/exceptions/{exceptionId}/{uuid}-{fileName}.
 * Returns the object path — the `uri` the exceptions media[] refs expect; storage rules
 * scope reads/writes to the tenant prefix, so the path MUST start with businessId.
 */
export const uploadExceptionMediaFile = async ({
  businessId,
  accountId,
  workOrderId,
  exceptionId,
  file,
}: UploadExceptionMediaFileArgs): Promise<string> => {
  const firebaseApp = getApp()
  const bucketStorage = getStorage(firebaseApp, `gs://${IMAGE_UPLOADS_PRIVATE_BUCKET_NAME}`)
  const objectPath = `${businessId}/accounts/${accountId}/work_orders/${workOrderId}/exceptions/${exceptionId}/${buildUniqueMediaObjectName(
    file.name
  )}`
  const fileRef = ref(bucketStorage, objectPath)
  await uploadBytes(fileRef, file, file.type ? { contentType: file.type } : undefined)
  return objectPath
}

export default uploadExceptionMediaFile
